import React from 'react';
import { Card } from 'react-bootstrap';
import { RichText } from '@components/common/RichText';

/**
 * Base Question Card Component
 */
export function QuestionCard({ question, children, className = '', headerContent = null }) {
  return (
    <Card className={`question-card ${className}`}>
      <Card.Body>
        {headerContent}
        <div className="question-text">
          <RichText value={question.text} as="div" />
        </div>

        {children}
      </Card.Body>
    </Card>
  );
}
